import {
  RECEIVE_JE_LINES,
  RECEIVE_AP_LINES,
  RECEIVE_PO_LINES,
  RECEIVE_PC_LINES,
  RECEIVE_AR_LINES,
  RECEIVE_BP_LINES,
  RECEIVE_PP_LINES,
  SAVING_JE_LINES,
  SAVING_JE_LINES_FAILURE,
  SAVING_AP_LINES,
  SAVING_AP_LINES_FAILURE,
  SAVING_PO_LINES,
  SAVING_PO_LINES_FAILURE,
  SAVING_PC_LINES,
  SAVING_PC_LINES_FAILURE,
  SAVING_AR_LINES,
  SAVING_BP_LINES,
  SAVING_PP_LINES,
  UPDATING_JE_LINES,
  UPDATING_JE_LINES_FAILURE,
  UPDATING_AP_LINES,
  UPDATING_AP_LINES_FAILURE,
  UPDATING_PO_LINES,
  UPDATING_PO_LINES_FAILURE,
  UPDATING_PC_LINES,
  UPDATING_PC_LINES_FAILURE,
  UPDATING_AR_LINES,
  UPDATING_BP_LINES,
  UPDATING_PP_LINES
} from '@/store/mutationTypes'

export function setLineSaveMutation (type) {
  let ret = { receiveMutation: null, savingMutation: null, savingFailureMutation: null }
  switch (type) {
    case 'jes':
      ret.receiveMutation = RECEIVE_JE_LINES
      ret.savingMutation = SAVING_JE_LINES
      ret.savingFailureMutation = SAVING_JE_LINES_FAILURE
      break
    case 'aps':
      ret.receiveMutation = RECEIVE_AP_LINES
      ret.savingMutation = SAVING_AP_LINES
      ret.savingFailureMutation = SAVING_AP_LINES_FAILURE
      break
    case 'pos':
      ret.receiveMutation = RECEIVE_PO_LINES
      ret.savingMutation = SAVING_PO_LINES
      ret.savingFailureMutation = SAVING_PO_LINES_FAILURE
      break
    case 'pcs':
      ret.receiveMutation = RECEIVE_PC_LINES
      ret.savingMutation = SAVING_PC_LINES
      ret.savingFailureMutation = SAVING_PC_LINES_FAILURE
      break
    case 'ars':
      ret.receiveMutation = RECEIVE_AR_LINES
      ret.savingMutation = SAVING_AR_LINES
      break
    case 'bps':
      ret.receiveMutation = RECEIVE_BP_LINES
      ret.savingMutation = SAVING_BP_LINES
      break
    case 'pps':
      ret.receiveMutation = RECEIVE_PP_LINES
      ret.savingMutation = SAVING_PP_LINES
  }
  return ret
}

export function setLineUpdateMutation (type) {
  let ret = { receiveMutation: null, updateMutation: null, updateFailMutation: null }
  switch (type) {
    case 'je':
      ret.receiveMutation = RECEIVE_JE_LINES
      ret.updateMutation = UPDATING_JE_LINES
      ret.updateFailMutation = UPDATING_JE_LINES_FAILURE
      break
    case 'ap':
      ret.receiveMutation = RECEIVE_AP_LINES
      ret.updateMutation = UPDATING_AP_LINES
      ret.updateFailMutation = UPDATING_AP_LINES_FAILURE
      break
    case 'po':
      ret.receiveMutation = RECEIVE_PO_LINES
      ret.updateMutation = UPDATING_PO_LINES
      ret.updateFailMutation = UPDATING_PO_LINES_FAILURE
      break
    case 'pc':
      ret.receiveMutation = RECEIVE_PC_LINES
      ret.updateMutation = UPDATING_PC_LINES
      ret.updateFailMutation = UPDATING_PC_LINES_FAILURE
      break
    case 'ar':
      ret.receiveMutation = RECEIVE_AR_LINES
      ret.updateMutation = UPDATING_AR_LINES
      break
    case 'bp':
      ret.receiveMutation = RECEIVE_BP_LINES
      ret.updateMutation = UPDATING_BP_LINES
      break
    case 'pp':
      ret.receiveMutation = RECEIVE_PP_LINES
      ret.updateMutation = UPDATING_PP_LINES
  }
  return ret
}
